import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    closeCancelAutoRenewConfirmDialog,
    renderCancelAutoRenewConfirmDialog,
} from 'reactApp/components/CancelAutoRenewConfirmDialog/CancelAutoRenewConfirmDialog.helpers';
import type { OutflowOfferMobileProps, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { SUBSCRIPTION_ANALYTICS } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscription.analytics';
import { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';
import {
    closeCancelAutoRenewalModal,
    renderCancelAutoRenewalModal,
} from 'reactApp/ui/Mobile/CancelAutoRenewalModal/CancelAutoRenewalModal.helpers';
import { renderSubscriptionsModal } from 'reactApp/ui/Mobile/SubscriptionsModal/SubscriptionsModal.helpers';
import { sendDwh } from 'reactApp/utils/ga';
import { select } from 'typed-redux-saga';

export function* cancelAutoRenewOffer({ subscription, sendAnalytics, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    const { isTrial, isPrepaid } = subscription;
    yield renderCancelAutoRenewConfirmDialog({
        subscription,
        isVkMusic: false,
        isTrial: isTrial && !isPrepaid,
        onAction() {
            closeCancelAutoRenewConfirmDialog();
            continueOutflow();
            sendAnalytics?.(ESubscriptionModalAction.cancelAutopayment);
            emitAnalyticEvent(AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_TRUE, { isTrial });
        },
        onClose() {
            closeCancelAutoRenewConfirmDialog();
            cancelOutflow();
            sendAnalytics?.(ESubscriptionModalAction.closeCancelAutopayment);
        },
        onSuccess() {
            closeCancelAutoRenewConfirmDialog();
            cancelOutflow();
            sendAnalytics?.(ESubscriptionModalAction.notCancelAutopayment);
            emitAnalyticEvent(AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_SAVE, { isTrial });
        },
    });
}

export function* cancelAutoRenewOfferMobile({
    subscription,
    dwhData,
    isRebranding,
    isRebrandingQuotaLanding,
    continueOutflow,
    cancelOutflow,
}: OutflowOfferMobileProps) {
    const { id, expires, space } = subscription;

    const userQuota = yield* select(UserQuotaSelectors.getTotal);
    const userQuotaSpace = userQuota ? userQuota.original : 0;
    const availableSpace = bytesToNDigits(Math.abs(space.original - userQuotaSpace), 3).value;

    yield renderCancelAutoRenewalModal({
        id,
        currentSpace: space.value,
        availableSpace,
        expires,
        dwhData,
        isRebrandingQuotaLanding,
        isRebranding,
        onAction() {
            closeCancelAutoRenewalModal();
            sendDwh({
                ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP2_CANCEL,
                dwhData,
            });
            continueOutflow();
        },
        onClose() {
            closeCancelAutoRenewalModal();
            cancelOutflow();
        },
        onSuccess() {
            closeCancelAutoRenewalModal();
            sendDwh({
                ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP2_SAFE_SUBS,
                dwhData,
            });
            cancelOutflow();
            renderSubscriptionsModal({ isRebrandingQuotaLanding, isRebranding });
        },
    });
}
